import { isSumaho } from '../common/isSumaho';

export function bn() {
  if (isSumaho()) {
    $('body').append(`
      <div class="bn">
        <p data-menu class="bn-menu">MENU</p>
        <p data-rsv class="bn-rsv">宿泊予約</p>
      </div>
    `);

    $('[data-menu]').on('click', function () {
      $('.menu').show();
    });
  }
}
